import React from 'react';
import { useTranslation } from 'react-i18next';
import UpgradeCard from '../subscription/UpgradeCard';

const NoteCardUpgrade = ({ source }) => {
  const { t } = useTranslation();

  return (
    <div
      data-testid="case-upgrade-overlay"
      style={{
        position: 'absolute',
        top: '120px',
        left: '20px',
        right: '20px',
        background: 'linear-gradient(180deg, rgba(255,255,255,0.3) 0%, rgba(255,255,255,0.5) 8%, rgba(255,255,255,0.7) 20%, rgba(255,255,255,0.85) 35%, rgba(255,255,255,0.95) 50%, rgba(255,255,255,0.98) 65%, rgba(255,255,255,1) 85%)',
        backdropFilter: 'blur(4px)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '40px 20px',
        borderRadius: '10px',
        zIndex: 10,
        transition: 'all 0.4s ease-in-out'
      }}
    >
      <UpgradeCard 
        paywallReason={source.paywallReason()} 
        title={t('note_card_upgrade.title')}
        buttonText={t('note_card_upgrade.upgrade_button')}
      />
    </div>
  );
};

export default NoteCardUpgrade; 